import ReactDOM from "react-dom/client";
import App from "./App";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from "react-router-dom";
import Company from "./pages/Company";
import Anketa from "./pages/Anketa";
import { getData } from "./app/utils/api";
import { data } from "@remix-run/router/dist/utils";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route
        path="companies"
        loader={async () => {
          try {
            const searchParams = new URLSearchParams(window.location.search);
            const company = searchParams.get("company_id");
            const key = searchParams.get("access_key");
            if (!company || !key)
              return {
                message: "Обратитесь к менеджеру за ключами",
              };

            const data = await getData({
              url: "/api/v1/auth/check_access_key",
              method: "POST",
              data: {
                company_id: company,
                access_key: key,
              },
            });

            return data;
          } catch (e) {
            return {};
          }
        }}
        element={<Company />}
      />
      <Route
        path="anketa/:id?"
        loader={async ({ request }) => {
          try {
            const security =
              new URL(request.url).searchParams.get("security") || "";

            const data = await getData({
              url: `/api/v1/anketa/start_point`,
              method: "POST",
              data: {
                security,
              },
            });

            return { data, security };
          } catch (e) {
            return {};
          }
        }}
        element={<Anketa />}
      />
      <Route path="*" element={<Navigate to="companies" replace />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<RouterProvider router={router} />);
